// const baseUrl = "http://localhost:5000";
const baseUrl = "https://piratext-be.herokuapp.com";

export default baseUrl;